export default __webpack_public_path__ + "static/media/bookmark.8e72a7af.svg";